import { userLikelyAuthed } from '@netlify/app-auth'
import queryString from 'query-string'
import { useEffect, useState } from 'react'

import DevAccessToken from '~/components/DevAccessToken'
import DevListDeploys from '~/components/DevListDeploys'
import Drawer from '~/components/Drawer'
import { SESSION_STORAGE_KEY } from '~/helpers/auth'
import { VCS } from '~/interfaces/types'
import { useActions, useStore } from '~/store/hooks'
import { getEnvironmentFromWindowLocation } from '~/utils/env'
import { initMessageListener } from '~/utils/messages'
import { CONTEXT } from '~/utils/tokens'

type Props = {
  deployID: string
  siteID: string
  vcs?: VCS
}

export default function Index() {
  const ready = useStore(state => state.hud.ready)
  const init = useActions(actions => actions.netlify.init)
  const initialFetch = useActions(actions => actions.hud.initialFetch)
  const postLoginFetch = useActions(actions => actions.hud.postLoginFetch)

  const [screen, setScreen] = useState('drawer')

  useEffect(() => {
    const env = getEnvironmentFromWindowLocation()

    // should only be allowed to load inside a frame on staging/production
    if (window === window.top && CONTEXT === 'production' && (env === 'staging' || env === 'production')) {
      // punish by redirect
      document.location.assign('/')
      return
    }

    const { deployID, siteID, vcs } = queryString.parse(document.location.search) as Props

    // if we're developing locally, OR we're visiting quokka-ui in local development / deploy preview / branch deploy
    if (window === window.top && CONTEXT !== 'production') {
      if (!deployID || !siteID) {
        if (!userLikelyAuthed({ storageKeyOverride: SESSION_STORAGE_KEY })) {
          setScreen('token')
        } else {
          setScreen('deploys')
        }
        return
      }
    }

    init({ deployID, siteID, vcs })

    // inform parent window that we're ready to go
    if (window.parent) {
      // receive messages from Deploy Preview parent frame
      initMessageListener(deployID, async () => {
        await initialFetch()
        await postLoginFetch()
      })
    }

    initialFetch()
  }, [])

  if (screen === 'token') {
    return <DevAccessToken />
  }

  if (screen === 'deploys') {
    return <DevListDeploys />
  }

  if (ready) {
    return <Drawer />
  }

  return null
}
